<div class="modal-body">

    <!-- <div class="row"> -->
        <!-- <div class="col-12"> -->
            <div class="titel-content">
                <span class="titel">
                    На вашу почту <span><a class="titel-link" target="_blank" href="https://mail.google.com/">{{email}}</a></span> был отправлен код подтверждения
                </span>
            </div>
        <!-- </div> -->
    <!-- </div> -->

    <form class="form" autocomplete="off" [formGroup]="formConfirm">

        <div class="form-inner">
            <div class="form-group">
                <div class="form-content input-group">
                    <input type="text" class="form-control" id="confirmation_code" placeholder="Введите код" formControlName="confirmation_code">
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.confirmation_code">
                            <div class="text-error" *ngIf="validation('confirmation_code', item.type)">
                                    {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
    <div class="progress-bar_wrapper">
        <div class="progress-bar_value">
            <div class="value-show">
                {{seconds}}с
            </div>
            <div>
                <ngb-progressbar class="danger"
                    *ngIf="seconds >= 0 && seconds <= 39" type="danger"
                    textType="white" [value]="seconds"></ngb-progressbar>
                <ngb-progressbar class="warning"
                    *ngIf="seconds >= 40 && seconds <= 79" type="warning"
                    textType="white" [value]="seconds"></ngb-progressbar>
                <ngb-progressbar class="success" *ngIf="seconds >= 80 && seconds <= 160" type="success"
                    textType="white" [value]="seconds"></ngb-progressbar>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer btn-box">
    <!-- [disabled]="formConfirm.invalid || seconds <= 0" -->
    <button type="button" class="btn btn-light btn-sm btn-action" (click)="activeModal.dismiss(true);">{{ 'Отмена' | translate}}</button>
    <button type="button" class="btn btn-primary btn-sm btn-action" (click)="checkRegistration()">{{ 'CONFIRM'| translate}}</button>
</div>